/**
 * 课程筛选结果
 */
export default {
  loadMoreButtonName: '加載更多',
  errorNotice: '加載失敗，請稍後重試。',
  emptyNotice: '此類別下沒有課程，請瀏覽其他年級的課程。',
}
